import { createSlice } from "@reduxjs/toolkit";

const setLoading = (state, value) => {
  state.isLoading = value;
};

const setSuccessWithData = (state, data, key) => {
  state.isLoading = false;
  state[key] = data;
};

const setFailure = (state) => {
  state.isLoading = false;
  state.isAuthenticated = false;
};

const schedualerSlice = createSlice({
  name: "Schedualer",
  initialState: {
    isLoading: false,

    // farmer: {},
    schedualersList: [],
    
    //regionList: [],
  },
  reducers: {

     // Create schedualer
     createSchedualerRequest: (state) => setLoading(state, true),
     createSchedualerSuccess: (state) => setLoading(state, false),
     createSchedualerFailure: (state) => setLoading(state, false),

      // Edit schedualer
     editSchedualerRequest: (state) => setLoading(state, true),
     editSchedualerSuccess: (state) => setLoading(state, false),
     editSchedualerFailure: (state) => setLoading(state, false),
    // schedualer list
    getSchedualerRequest: (state) => setLoading(state, true),
    getSchedualerSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "schedualersList"),
    getSchedualerFailure: (state) => setLoading(state, false),

    // delete schedualer 
    deleteSchedualerRequest: (state) => setLoading(state, true),
    deleteSchedualerSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "schedualersList"),
    deleteSchedualerFailure: (state) => setLoading(state, false),


    // delete schedualer 
    deleteTaskRequest: (state) => setLoading(state, true),
    deleteTaskSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "schedualersList"),
    deleteTaskFailure: (state) => setLoading(state, false),



  },
});

export const {
  getSchedualerRequest,
  getSchedualerSuccess,
  getSchedualerFailure,
  createSchedualerRequest,
  createSchedualerSuccess,
  createSchedualerFailure,
  editSchedualerRequest,
  editSchedualerSuccess,
  editSchedualerFailure,
  deleteSchedualerRequest,
  deleteSchedualerSuccess,
  deleteSchedualerFailure,
   deleteTaskRequest,
  deleteTaskSuccess,
  deleteTaskFailure,
} = schedualerSlice.actions;

export const schedualerReducerSlice = schedualerSlice.reducer;
